import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from "pdfmake/build/vfs_fonts"
import { ContaAReceber, HeaderPDF, ProdutoEstoque } from '../../../Utils/Types';
import { Funcoes } from '../../../Utils/Funcoes';
import moment from 'moment';

export class RelContaReceberGeralPDF {

  private headers: HeaderPDF[] = []
  private dadosContaReceber: ContaAReceber[]
  private body: any
  private corpoDocumento: any
  private totalDuplicata: any
  private totalValor: any
  private dadosEmpresa: any
  private colunaDtBaixa: boolean

  constructor(dadosContaReceber: ContaAReceber[], totalDuplicata: any, totalValor: any, colunaDtBaixa: boolean) {
    this.dadosContaReceber = dadosContaReceber
    this.totalDuplicata = totalDuplicata
    this.totalValor = totalValor
    this.colunaDtBaixa = colunaDtBaixa
  }

  /*
  async CriaDocumento() {
      const bBody: any = this.dadosContaReceber.map((dados) => {
          return [
            { text: dados.id, fontSize: 10 },
            { text: dados.nome_cliente, fontSize: 10 },
            { text: dados.data_vencimento, fontSize: 10 },
            { text: dados.valor, fontSize: 10 },
            { text: dados.valor_original, fontSize: 10 },
          ]
      })

      this.body = [
          { text: "Duplicata", fontSize: 10 },
          { text: "Cliente", fontSize: 10 },
          { text: "Data de Vencimento", fontSize: 10 },
          { text: "Valor", fontSize: 10 },
          { text: "Valor Original", fontSize: 10 },
      ]

      const lineHeader = [
          {
            text: '____________________________________________________________________________________________________________________________________________________________________________',
            aligment: 'center',
            fontSize: 5,
            colSpan: 3
          }, {}, {},
      ]

      let content = [this.headers, lineHeader];
      content = [...content, ...this.body];
      this.corpoDocumento = content;
  }
  */

  /*
  GerarDocumento() {

      const document = {
        pageSize: 'A4',
        pageMargins: [2, 53, 2, 48],
        header: () => {
          return {
            margin: [2, 12, 2, 0],
            layout: 'noBorders',
            table: {
              widths: ['*'],
              body: [
                [
                  { text: 'Relatório de Duplicatas', style: 'reportName' }
                ]
              ],
            },
          };
        },
        content: [
          {
            layout: 'noBorders',
            table: {
              headerRows: 1,
              widths: ['*', 55, 55],
              body: this.corpoDocumento
            }
          },
        ],
        footer: (currentPage: number, pageCount: number) => {
          return {
            layout: 'noBorders',
            margin: [2, 0, 2, 22],
            table: {
              widths: ['auto'],
              body: [
                [
                  {
                    text: '_________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________',
                    alignment: 'center',
                    fontSize: 5,
                  },
                ],
                [
                  [
                    {
                      text: `Página ${currentPage.toString()} de ${pageCount}`,
                      fontSize: 7,
                      alignment: 'right',
                      // horizontal, vertical
                      margin: [3, 0],
                    },
                    {
                      text: '© Lojinha de TI',
                      fontSize: 7,
                      alignment: 'center',
                    },
                  ],
                ],
              ],
            },
          };
        },
        styles: {
          reportName: {
            fontSize: 9,
            bold: true,
            alignment: 'center',
            margin: [0, 4, 0, 0],
          }
        },
      };
  
      return document;
  }
  */




  async GerarPDF(dadosContaReceber: ContaAReceber[]) {

    const calcularTotal = (ctaReceberList: ContaAReceber) => {

      const hoje = new Date()
      const taxaPadrao = parseFloat(localStorage.getItem("@ecommerce/taxa_juros") || '0')
      const dias = Number(localStorage.getItem("@ecommerce/diasJuros") || 0)
      let total = 0

      const vencimentoBase = new Date(ctaReceberList.data_vencimento);

      // Soma os dias
      const vencimento = new Date(vencimentoBase);
      vencimento.setDate(vencimento.getDate() + 1 + dias);
      let juros = 0

      if (ctaReceberList.data_vencimento && vencimento < hoje) {
        const hojeZero = new Date(hoje)
        hojeZero.setHours(0, 0, 0, 0)

        const vencZero = new Date(vencimento)
        vencZero.setHours(0, 0, 0, 0)

        const diffTime = hojeZero.getTime() - vencZero.getTime()
        const diffDias = Math.max(Math.floor(diffTime / (1000 * 60 * 60 * 24)), 0)

        if (diffDias > 0) {
          const taxaPercent = taxaPadrao || 0        // ex.: 5 = 5% ao mês
          const taxaDiaria = (taxaPercent / 100) / 30 // proporcional ao mês
          juros = ctaReceberList.valor_original * taxaDiaria * diffDias // juros simples
        }

        total += juros

        return parseFloat(total.toFixed(2))
      }
    }

    let widths = ['10%', '5%', '41%', '12%', '12%', '20%']
    let headerRow = [
      { text: 'Dup', alignment: 'center', fontSize: 10, margin: [0, 4, 0, 4], border: [false, true, true, false] },
      { text: 'Série', alignment: 'center', fontSize: 10, margin: [0, 4, 0, 4], border: [false, true, true, false] },
      { text: 'Cliente', alignment: 'left', fontSize: 10, margin: [0, 4, 0, 4], border: [false, true, true, false] },
      { text: 'Emissão', alignment: 'center', fontSize: 10, margin: [0, 4, 0, 4], border: [false, true, true, false] },
      { text: 'Vencimento', alignment: 'center', fontSize: 10, margin: [0, 4, 0, 4], border: [false, true, true, false] },
      { text: 'Valor', alignment: 'right', fontSize: 10, margin: [0, 4, 0, 4], border: [false, true, false, false] },
    ]

    // Se quiser adicionar ou remover a coluna
    if (this.colunaDtBaixa) {
      const posicaoValor = widths.length - 1 // índice da coluna "Valor"
      widths = ['8%', '5%', '35%', '12%', '12%', '12%', '16%']
      headerRow.splice(posicaoValor, 0, { text: 'Baixa', alignment: 'center', fontSize: 10, margin: [0, 4, 0, 4], border: [false, true, true, false] })
    }


    // ----------------------------------------------------------

    this.dadosEmpresa = Funcoes.GetDadosEmpresa()

    pdfMake.vfs = pdfFonts.pdfMake.vfs

    let dados = dadosContaReceber.map((item: ContaAReceber) => {

      let valorTotal = calcularTotal(item)

      let linha = [
        { text: item.id, alignment: 'center', fontSize: 9, margin: [0, 2, 0, 2], border: [false, true, true, true] },
        { text: item.serie, alignment: 'center', fontSize: 9, margin: [0, 2, 0, 2], border: [false, true, true, true] },
        { text: item.nome_cliente, alignment: 'left', fontSize: 9, margin: [0, 2, 0, 2], border: [false, true, true, true] },
        { text: moment(item.dt_cadastro).format("DD/MM/YYYY"), alignment: 'center', fontSize: 9, margin: [0, 2, 0, 2], border: [false, true, true, true] },
        { text: moment(item.data_vencimento).format("DD/MM/YYYY"), alignment: 'center', fontSize: 9, margin: [0, 2, 0, 2], border: [false, true, true, true] },
        { text: Funcoes.numberFormat(item.valor + (valorTotal || 0), 'currency', 2, 2), alignment: 'right', fontSize: 9, margin: [0, 2, 0, 2], border: [false, true, false, true] }
      ]

      if (this.colunaDtBaixa) {
        const posicaoValor = linha.length - 1 // antes da última coluna
        linha.splice(posicaoValor, 0, { text: moment(item.dt_baixa).format("DD/MM/YYYY") || '', alignment: 'center', fontSize: 9, margin: [0, 2, 0, 2], border: [false, true, true, true] })
      }

      return linha
    })

    const details: any = [
      {
        layout: 'noBorders',
        margin: 0,
        table: {
          widths: ['*', '*', '*', '*', '*'],
          body: dados
        },
      }
    ]

    const footer = (currentPage: number, pageCount: number,) => {
      return [
        {
          layout: 'Borders',
          style: 'tableExample',
          margin: [5, 20, 5, 0],
          table: {
            headerRows: 1,
            widths: ['*'],
            body: [
              [{ text: 'Pág. ' + currentPage + '/' + pageCount, alignment: 'right', fontSize: 10, margin: [0, 0, 0, 0], border: [false, true, false, false] }],
            ]
          }
        },
      ]
    };

    const docDefinitions: any = {
      pageSize: 'A4',
      pageMargins: [5, 5, 5, 50],
      content: [
        /* Dados da Empresa Início */
        {
          layout: 'Borders',
          style: 'tableExample',
          table: {
            headerRows: 1,
            widths: ['*'],
            body: [
              [{ text: this.dadosEmpresa?.fantasia || '', bold: true, alignment: 'center', margin: [0, 2, 0, 0], fontSize: 13, border: [false, false, false, false] },],
              [{ text: 'CNPJ: ' + (Funcoes.FormatDoc(this.dadosEmpresa?.cnpj_cpf) || ''), bold: true, alignment: 'center', margin: [0, 0, 0, 0], fontSize: 13, border: [false, false, false, false] },],
              [{ text: (this.dadosEmpresa?.endereco || '') + (this.dadosEmpresa?.numero ? " N." + this.dadosEmpresa?.numero : '') + ' ' + (this.dadosEmpresa?.bairro || ''), bold: true, alignment: 'center', margin: [0, 0, 0, 0], fontSize: 13, border: [false, false, false, false] },],
              [{ text: (this.dadosEmpresa?.cidade || '') + " - " + (this.dadosEmpresa?.uf || ''), bold: true, alignment: 'center', margin: [0, 0, 0, 0], fontSize: 13, border: [false, false, false, false] },],
            ],
          },
        },
        /* Dados da Empresa Fim*/

        {
          layout: 'Borders',
          style: 'tableExample',
          table: {
            headerRows: 1,
            widths: ['*'],
            body: [
              [{ text: 'Relatório de Duplicatas a Receber', alignment: 'center', bold: true, fontSize: 12, border: [false, false, false, false], style: 'header', margin: [0, 0, 0, 2] },],
            ],
          },
        },


        {
          layout: 'Borders',
          style: 'tableExample',
          table: {
            widths: widths,
            body: [headerRow],
          },
        },

        {
          layout: 'Borders',
          style: 'tableExample',
          margin: [0, 0, 0, 0],
          table: {
            widths: widths,
            body: dados
          },
        },

        {
          layout: 'Borders',
          style: 'tableExample',
          margin: [0, 10, 0, 0],
          table: {
            headerRows: 1,
            widths: ['*', '*'],
            body: [

              [
                { text: 'Total Duplicatas: ' + this.totalDuplicata, bold: true, margin: [0, 0, 0, 0], alignment: 'left', fontSize: 10, border: [false, true, false, true] },
                { text: 'Total Valor: ' + Funcoes.numberFormat(this.totalValor, 'currency', 2, 2), bold: true, margin: [0, 0, 0, 0], alignment: 'right', fontSize: 10, border: [false, true, false, true] },
              ]
            ],
          },
        },

      ],
      footer: footer
    };

    pdfMake.createPdf(docDefinitions).print();

  }

}